function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "trash");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "trash",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "recycle-copy",
  transform: "translate(5.000000, 3.000000)",
  stroke: "currentColor",
  strokeWidth: 4
}, React.createElement("rect", {
  id: "Rectangle",
  x: 4,
  y: 8,
  width: 32,
  height: 36,
  rx: 2
}), React.createElement("rect", {
  id: "Rectangle",
  transform: "translate(20.000000, 4.000000) scale(-1, 1) rotate(-180.000000) translate(-20.000000, -4.000000) ",
  x: 12,
  y: 0,
  width: 16,
  height: 8,
  rx: 2
}), React.createElement("g", {
  id: "Group-27",
  strokeLinecap: "round",
  transform: "translate(11.000000, 20.000000)"
}, React.createElement("line", {
  x1: 0.5,
  y1: 3,
  x2: 0.5,
  y2: 9,
  id: "Path"
}), React.createElement("line", {
  x1: 8.5,
  y1: 0,
  x2: 8.5,
  y2: 12,
  id: "Path-Copy"
}), React.createElement("line", {
  x1: 16.5,
  y1: 3,
  x2: 16.5,
  y2: 9,
  id: "Path-Copy"
})), React.createElement("line", {
  x1: 20,
  y1: -12,
  x2: 20,
  y2: 28,
  id: "Path",
  strokeLinecap: "round",
  transform: "translate(20.000000, 8.000000) rotate(90.000000) translate(-20.000000, -8.000000) "
})));

var SvgTrash = function SvgTrash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash.a504176d.svg";
export { ForwardRef as ReactComponent };